"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_PRODUCTS = 'fetch-products';
exports.NAVIGATE_TO_PRODUCT = 'navigate-to-product';
exports.PREFETCH_PRODUCT = 'prefetch-product';
